import { DocumentReference, TypeGuard } from '@principle-theorem/shared';
import { isNumber, isString } from 'lodash';
import { ITreatmentStep } from '../../clinical-charting/treatment/treatment-step';
import { MohClaimType } from './moh';

export interface IMohPreApprovalCode {
  code: string;
  quantity: number;
  price: number;
  toothNumbers?: string;
}

export interface IMohPreApprovalData {
  stepRef: DocumentReference<ITreatmentStep>;
  codes: IMohPreApprovalCode[];
  claimType: MohClaimType;
  payeeNumber: string;
  agreementNumber: string;
  practitionerName: string;
  dcnzNumber: string;
  practiceAddress: string;
  patientName: string;
  patientDateOfBirth: string;
  nhiNumber: string;
  comments?: string;
}

export const isMohPreApprovalCode = TypeGuard.interface<IMohPreApprovalCode>({
  code: isString,
  quantity: isNumber,
  price: isNumber,
  toothNumbers: TypeGuard.undefinedOr(isString),
});
